export const PORTFOLIO_CONTENTS = [
    {
        id: 1,
        image: "/images/portfolio/technotic.png",
        imageTitle: "Technotic (Design System)",
        webLink: "https://technotic.bncc.net/",
        githubLink: "https://github.com/RnDBNCC/technotic",
        firstText: "ReactJS",
        secondText: "TypeScript",
    },
    {
        id: 2,
        image: "/images/portfolio/leap.png",
        imageTitle: "LEAP 2.1 (Learning Portal)",
        webLink: "https://member.bncc.net/",
        firstText: "ReactJS + TypeScript",
        secondText: "SASS (SCSS)",
    },
    {
        id: 3,
        image: "/images/portfolio/aloer.png",
        imageTitle: "Aloer",
        webLink: "https://aloer.co.id/",
        firstText: "NextJS",
        secondText: "TailwindCSS",
    },
    {
        id: 4,
        image: "/images/portfolio/technoscape-2023.png",
        imageTitle: "TechnoScape 2023",
        webLink: "https://technoscape.id/",
        firstText: "TailwindCSS",
        secondText: "ThreeJS",
    },
    {
        id: 5,
        image: "/images/portfolio/ds-bersatu.png",
        imageTitle: "DS Bersatu",
        webLink: "https://dsbersatu.com/",
        firstText: "Wordpress",
    },
    {
        id: 6,
        image: "/images/portfolio/umroh-vr.png",
        imageTitle: "UmrohVR",
        webLink: "https://umrohvr.co.id/",
        firstText: "Wordpress",
    },
    {
        id: 7,
        image: "/images/portfolio/cloudius.png",
        imageTitle: "Cloudius",
        webLink: "https://jonathanchr11.github.io/cloudius-final-project-lec/",
        githubLink:
            "https://github.com/JonathanChr11/cloudius-final-project-lec",
        firstText: "Bootstrap",
    },
    {
        id: 8,
        image: "/images/portfolio/skypics.png",
        imageTitle: "SkyPics",
        webLink: "https://jonathanchr11.github.io/skypics/",
        githubLink: "https://github.com/JonathanChr11/skypics",
        firstText: "VanillaJS",
    },
    {
        id: 9,
        image: "/images/portfolio/technoscape-2022.png",
        imageTitle: "TechnoScape 2022",
        webLink: "https://technoscape.id/",
        firstText: "TailwindCSS",
        secondText: "ThreeJS",
    },
    {
        id: 10,
        image: "/images/portfolio/seashell.png",
        imageTitle: "SeaShell",
        githubLink: "https://github.com/JonathanChr11/seashell-be",
        firstText: "TailwindCSS",
        secondText: "Laravel",
    },
    {
        id: 11,
        image: "/images/portfolio/instagram.png",
        imageTitle: "Instagram",
        githubLink: "https://github.com/JonathanChr11/login-instagram",
        firstText: "Dart",
        secondText: "Flutter",
    },
    {
        id: 12,
        image: "/images/portfolio/react-faq-pages.png",
        imageTitle: "FAQ Pages",
        webLink: "https://jonathanchr11.github.io/react-crud/",
        githubLink: "https://github.com/JonathanChr11/react-crud",
        firstText: "ReactJS",
    },
    {
        id: 13,
        image: "/images/portfolio/gui-workshop.png",
        imageTitle: "GUI Workshop",
        githubLink: "https://github.com/JonathanChr11/bworkshop-gui",
        firstText: "JavaSE",
        secondText: "JDBC",
    },
    {
        id: 14,
        image: "/images/portfolio/med-c.png",
        imageTitle: "Med-C",
        webLink: "https://med-c.la11ebusiness.xyz/",
        firstText: "Wordpress",
    },
    {
        id: 15,
        image: "/images/portfolio/coming-soon.png",
        imageTitle: "Revamp BNCC.net",
        webLink: "https://bncc.net/",
        firstText: "NextJS",
        secondText: "TailwindCSS",
    },
    {
        id: 16,
        image: "/images/portfolio/bandarkopi.png",
        imageTitle: "Bandar Kopi",
        webLink: "https://bandarkopi.co.id/",
        firstText: "ReactJS",
        secondText: "Laravel",
    },
];
